import React, { useState, useEffect } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
// import ChatOverlay from "../components/ChatOverlay";
import logo from "../assets/logo.png"
import axios from 'axios';
import useAuth from "../utils/auth"; 


const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const [user, setUser] = useState(null);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  const { logout } = useAuth();
  const navigate = useNavigate();
  
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchUser = async () => {
      try {

        const token = localStorage.getItem("authToken");
        if (!token) return;
        const response = await axios.get(`${API_BASE_URL}/api/v1/auth/profile`, {
          headers: {
            Authorization: `Bearer ${token}`, // Send token for authentication
          },
        });

        setUser(response.data); // Assuming response contains user data
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUser();
  }, [ API_BASE_URL]);


  return (
    <div className="flex h-screen bg-soft-white">
      {/* Sidebar */}
      <aside
        className={`${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } w-72 bg-navy text-soft-white fixed md:translate-x-0 md:static z-40 transition-transform duration-300 ease-in-out h-full overflow-y-auto`}
      >
        {/* Logo/Brand Section */}
        <div className="py-6 px-4 md:py-8 md:px-6 border-b border-charcoal-gray">
          <div className="flex items-center">
            <img 
              src={logo} 
              alt="PaySub Logo" 
              className="w-16 h-16 object-contain"
            />
          </div>
          <p className="text-light-gray mt-3 text-sm font-medium">
            A data subscription that pays you...
          </p>
        </div>

        {/* User Profile Section */}
        <div className="px-4 py-4 border-b border-charcoal-gray">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-emerald-green flex items-center justify-center">
              <span className="material-icons text-white">person</span>
            </div>
            <div>
              <h3 className="text-white font-medium">{user?.username}</h3>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="mt-4 md:mt-6 px-4">
          <ul className="space-y-1">
            <li>
              <Link
                to="/dashboard"
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors duration-200 ${
                  isActiveRoute('/dashboard')
                    ? 'bg-charcoal-gray text-golden-yellow'
                    : 'text-soft-white hover:bg-charcoal-gray'
                }`}
                onClick={toggleSidebar}
              >
                <span className="material-icons">dashboard</span>
                Dashboard
              </Link>
            </li>

            <li>
              <Link
                to="/dashboard/history"
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors duration-200 ${
                  isActiveRoute('/dashboard/history')
                    ? 'bg-charcoal-gray text-golden-yellow'
                    : 'text-soft-white hover:bg-charcoal-gray'
                }`}
                onClick={toggleSidebar}
              >
                <span className="material-icons">history</span>
                Transaction History
              </Link>
            </li>
            <li>
              <Link
                to="/dashboard/topup"
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors duration-200 ${
                  isActiveRoute('/dashboard/topup')
                    ? 'bg-charcoal-gray text-golden-yellow'
                    : 'text-soft-white hover:bg-charcoal-gray'
                }`}
                onClick={toggleSidebar}
              >
                <span className="material-icons">account_balance_wallet</span>
                Fund Wallet
              </Link>
            </li>
            <li>
              <Link
                to="/dashboard/profile"
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors duration-200 ${
                  isActiveRoute('/dashboard/profile')
                    ? 'bg-charcoal-gray text-golden-yellow'
                    : 'text-soft-white hover:bg-charcoal-gray'
                }`}
                onClick={toggleSidebar}
              >
                <span className="material-icons">person</span>
                Profile
              </Link>
            </li>
            {/* <li>
              <Link
                to="/dashboard/referrals"
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors duration-200 ${
                  isActiveRoute('/dashboard/referrals')
                    ? 'bg-charcoal-gray text-golden-yellow'
                    : 'text-soft-white hover:bg-charcoal-gray'
                }`}
              >
                <span className="material-icons">people</span>
                Referrals
              </Link>
            </li> */}
            <li>
              <Link
                to="/dashboard/support"
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors duration-200 ${
                  isActiveRoute('/dashboard/support')
                    ? 'bg-charcoal-gray text-golden-yellow'
                    : 'text-soft-white hover:bg-charcoal-gray'
                }`}
                onClick={toggleSidebar}
              >
                <span className="material-icons">support_agent</span>
                Support
              </Link>
            </li>
            <li>
              <button
                onClick={() => {logout();
                  navigate("/");}
                }
                className="flex w-full items-center gap-3 px-4 py-3 text-soft-white hover:bg-charcoal-gray rounded-lg transition-colors duration-200"
              >
                <span className="material-icons">logout</span>
                Logout
              </button>
            </li>
          </ul>
        </nav>
      </aside>

      {/* Main Content */}
      <div className="flex-grow flex flex-col w-full md:pl-72">
        {/* Topbar */}
        <header className="bg-white shadow-md px-4 md:px-6 py-3 md:py-4 flex justify-between items-center">
          {/* Mobile Menu Button */}
          <div className="flex items-center gap-4">
            <button
              onClick={toggleSidebar}
              className="block md:hidden text-navy hover:text-golden-yellow transition-colors p-1"
            >
              <span className="material-icons">menu</span>
            </button>
            <div className="hidden md:block">
              <h1 className="text-lg md:text-xl font-semibold text-navy">Welcome back, {user?.username}</h1>
              <p className="text-sm text-charcoal-gray">Manage PaySub services</p>
            </div>
          </div>

          {/* Right side actions */}
          <div className="flex items-center space-x-2 md:space-x-4">
            {/* Credits Display */}
            {/* <div className="hidden md:flex items-center bg-soft-white px-4 py-2 rounded-lg border border-light-gray">
              <span className="material-icons text-emerald-green mr-2">stars</span>
              <span className="text-navy font-medium">Credits: 100</span>
            </div>

            {/* Notifications */}
            {/* <button className="p-1.5 md:p-2 text-navy hover:text-golden-yellow rounded-full hover:bg-soft-white transition-all duration-200 relative">
              <span className="material-icons text-xl md:text-2xl">notifications</span>
              <span className="absolute top-0 right-0 h-2 w-2 bg-crimson-red rounded-full"></span>
            </button>  */}

            {/* Profile Dropdown */}
            <div className="relative">
              <Link to="/profile">
              <button className="flex items-center gap-2 text-navy hover:text-golden-yellow">
                <span className="material-icons">account_circle</span>
                <span className="hidden md:block">{user?.fullname}</span>
              </button>
              </Link>
            </div>
          </div>
        </header>

        {/* Main Content Area */}
        <div className="flex-grow p-4 md:p-6 overflow-auto">
          <Outlet />
        </div>

        <a
        href="https://wa.me/+2349158587145"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-[#25D366] hover:bg-[#20BA56] text-white w-12 h-12 rounded-full shadow-lg transition-colors duration-200 z-40 flex items-center justify-center"
      >
        <i className="fab fa-whatsapp text-lg group-hover:scale-110 transition-transform duration-300"></i>
      </a>
      </div>
      {/* Overlay for mobile sidebar */}
      {isSidebarOpen && (
        <div
          onClick={toggleSidebar}
          className="fixed inset-0 bg-charcoal-gray bg-opacity-50 z-30 md:hidden"
        ></div>
      )}
    </div>
  );
};

export default Dashboard;